<template>
    <template-card-v2
        :one-log="oneLog"
        :linkedtype="linkedtype"
        :linkedid="linkedid"
        :has-history="false"
    >
        <template slot="label">{{ oneLog.title }}</template>

        <div slot="content" class="pre-line" v-html="oneLog.content" />
    </template-card-v2>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';

export default {
    components: {
        TemplateCardV2,
    },
    mixins: [TimelineCardMixin],
    data() {
        return {
            lang: this.$parent.lang,
        };
    },
};
</script>
<style lang="scss" scoped>
.pre-line {
    white-space: pre-line;
}
</style>
